import { useAuth } from 'src/auth/AuthContext';
import React from 'react';
import './App.css';
import RouterConfig from './navigation/RouterConfig';
import AppLoader from './components/AppLoader';

const App: React.FC = () => {
  // The Firebase auth listener fires asynchronously after mount, so on every
  // load there is a window where nobody knows yet whether a user is signed in.
  // Hold the whole router behind the app loader until that settles: otherwise
  // routes mount against an undecided auth state, which bounces signed-in
  // users to /login and flashes empty states on data that has not been
  // requested yet. Past this gate, loading is each page's own concern.
  const bootstrapped = useAuth().bootstrapped;

  if (!bootstrapped) {
    return <AppLoader />;
  }

  return <RouterConfig />;
};

export default App;
